const renderAgeCheck = (crossrefChecks, showDivider) => {
    const formatAgeCheck = (ageCheckItem, index) => {
        let ageCheckFormattedResult = ageCheckItem.reason === 'too_old' ? 'Too old' : 'Too recent';
        const now = new Date();
        const publishedDate = new Date(ageCheckItem.originalData.publishedDate);
        const yearDiffs = Math.floor((now - publishedDate) / 1000 / 60 / 60 / 24 / 365);
        ageCheckFormattedResult += `, ${yearDiffs} years old`;

        return <p key={index} className="mb-1">{index + 1}. {ageCheckItem.doi} {ageCheckFormattedResult}</p>
    };

    return (
        <div className="mb-2">
            <div className="mt-2 mb-1"><b>Age check: </b></div>
            {crossrefChecks.ageCheck.map((ac, index) => formatAgeCheck(ac, index))}
            {showDivider && <hr className="hr" />}
        </div>
    );
};

const renderCitationCartel = (crossrefChecks, showDivider) => {
    const formatDoiLink = (doi) => {
        if (!doi) return doi;
        // Check if DOI already has http/https
        if (doi.startsWith('http://') || doi.startsWith('https://')) {
            return doi;
        }
        // Prepend https://doi.org/ if not already a URL
        return `https://doi.org/${doi}`;
    };

    const formatCitationCartel = (citationCartelItem, index) => {
        const doi = citationCartelItem.suspiciousDoi;
        const doiUrl = formatDoiLink(doi);
        
        return (
            <p key={index} className="mb-1">
                {index + 1}. Highly cited DOI:{' '}
                <a href={doiUrl} target="_blank" rel="noopener noreferrer">
                    {doi}
                </a>
                , cited by {citationCartelItem.count} articles in reference list
            </p>
        );
    };

    return (
        <div className="mb-2">
            <div className="mt-2 mb-1"><b>Citation cartel: </b></div>
            {crossrefChecks.citationCartel.map((cc, index) => formatCitationCartel(cc, index))}
            {showDivider && <hr className="hr" />}
        </div>
    );
};

const renderSelfCitation = (crossrefChecks, showDivider) => (
    <div className="mt-2 mb-2">
        <b>Self citation: </b><span>self citation</span>
        {showDivider && <hr className="hr" />}
    </div>
);

const renderTitleComparison = (crossrefChecks, showDivider) => {
    const formatTitleComparison = (item, index) => (
        <p key={index} className="mt-2 mb-1">
            {index + 1}. {item.doi}{' '}
            <span>
                Title <i>"{item.originalTitle}"</i> does not match the title from Crossref: <i>"{item.title}"</i>
            </span>
        </p>
    );

    return (
        <div className="mb-2">
            <div className="mt-2 mb-1"><b>Title match: </b></div>
            {crossrefChecks.titleMatch.map((tm, index) => formatTitleComparison(tm, index))}
            {showDivider && <hr className="hr" />}
        </div>
    );
};

const renderJournalComparison = (crossrefChecks) => {
    const formatJournalComparison = (item, index) => (
        <p key={index} className="mb-1">
            {index + 1}. {item.doi}{' '}
            <span>
                Journal <i>"{item.originalJournal}"</i> does not match the journal from Crossref: <i>"{item.journal}"</i>
            </span>
        </p>
    );

    return (
        <div className="mb-2">
            <div className="mb-1"><b>Journal match: </b></div>
            {crossrefChecks.journalMatch.map((jm, index) => formatJournalComparison(jm, index))}
        </div>
    );
};

export const renderCrossrefChecksItem = (crossrefChecks) => {
    const sections = [
        { key: 'ageCheck', render: renderAgeCheck },
        { key: 'citationCartel', render: renderCitationCartel },
        { key: 'selfCitation', render: renderSelfCitation },
        { key: 'titleMatch', render: renderTitleComparison },
        { key: 'journalMatch', render: renderJournalComparison },
    ];

    const activeSections = sections.filter(s => crossrefChecks[s.key]);

    return (
        <div>
            {activeSections.map((section, index) => {
                const isLast = index === activeSections.length - 1;
                return <div key={section.key}>{section.render(crossrefChecks, !isLast)}</div>;
            })}
        </div>
    );
};